import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICoachRegistryModel, CoachAccrual } from 'app/common/models/coach-registry.model';
import { CoachRegistryService } from 'app/components/coaches/services/coach-registry.service';
import { AlertsService } from 'app/common/components/alerts/services/alerts.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CoachesRateCalculateService } from '../../services/coaches-rate-calculate.service';

@Component({
  selector: 'app-coachregistry-element-add',
  templateUrl: './coachregistry-element-add.component.html',
  styleUrls: ['./coachregistry-element-add.component.scss']
})
export class CoachRegistryElementAddComponent implements OnInit {

  @Input() registry: ICoachRegistryModel;
  @Input() table: any;
  @Output() result = new EventEmitter<CoachAccrual>();
  isOpenPersonRatePopup = false;
  isOpenClassRatePopup = false;

  public form: FormGroup;
  public params: any = {};
  public aliasParams: any[] = [];
  public selectedAlias: any = {};
  public aliases: any[] = [];
  public coachSalaryCalculators = {
    "class": {
      aliasDisplayName: "Ставка за занятие",
      func: this.calcSalaryClass,
      params: ["class"]
    },
    "personInGroup": {
      aliasDisplayName: "Ставка за человека",
      func: this.calcSalaryPersonInGroup,
      params: ["personInGroupRate", "personCount"]
    },
    "pctWithMissed": {
      aliasDisplayName: "% от занятия, включая пропуски",
      func: this.calcSubscriptionPercent,
      params: ["subscriptionPercentRate", "forUnlimitedRate", "personCount"]
    },
    "pctWithoutMissed": {
      aliasDisplayName: "% от занятия без пропусков",
      func: this.calcSubscriptionPercent,
      params: ["subscriptionPercentRate", "forUnlimitedRate", "personCount"]
    },
    "subscription": {
      aliasDisplayName: "Процент от абонемента",
      func: this.calcSubscriptionPercent,
      params: ["subscriptions", "personCount"]
    },
    "progressiveRate": {
      aliasDisplayName: "Прогрессивная ставка",
      func: this.calcProgressive,
      params: ["personCount", "classesRate", "personsRate"]
    },
    "salary": {
      aliasDisplayName: "Оклад",
      func: this.calcSalary,
      params: ["salary"]
    },
    "other": {
      aliasDisplayName: "Прочее",
      func: this.calcAdditional,
      params: ["other"]
    }
  };

  private group: any = {};
  private basicParams: any;



  constructor(
    private coachRegistryService: CoachRegistryService,
    private alertsService: AlertsService,
    private coachesRateCalculate: CoachesRateCalculateService
  ) { }

  async ngOnInit(): Promise<any> {

    this.basicParams = this.coachesRateCalculate.basicParams;
    this.selectedAlias = "other";
    this.aliases = Object.keys(this.coachSalaryCalculators).filter(key => key !== "subscription");

    this.params = {
      "class": 0,
      "salary": 0,
      "personInGroupRate": 0,
      "personCount": 0,
      "duration": 0,
      "other": 0,
      "subscriptions": 0,
      "subscriptionPercentRate": 0,
      "forUnlimitedRate": 0,
      "classesRate": "0=0",
      "personsRate": "0=0",
      "classesCount": "0",

    };
    try {
      for (const item of this.table[1]) {
        const params = JSON.parse(item.params);
        if (params.classesCount) {
          this.params["classesCount"] = params.classesCount;
          break;
        }
      }
    }
    catch {
      console.log("Ошибка при поиске количества занятий")
    }
    this.aliasParams.push({
      name: "title",
      displayName: "Комментарий",
      type: "text",
      formControlName: "title",
      value: ""
    })
    for (let p of this.coachSalaryCalculators[this.selectedAlias].params) {
      this.aliasParams.push({
        name: p,
        displayName: this.basicParams[p].paramDisplayName,
        type: this.basicParams[p].paramType,
        formControlName: p,
        value: this.params[p]
      })
    }
    if (this.aliasParams.length) {
      this.group[this.aliasParams[0].name] = new FormControl(this.aliasParams[0].value.toString().replace('&lt;', '<').replace('&gt;', '>'), Validators.required)
      for (let i = 1; i < this.aliasParams.length; i++) {
        this.group[this.aliasParams[i].name] = new FormControl(this.aliasParams[i].value.toString(), Validators.required)
      }
      this.form = new FormGroup(this.group);
    }
  }

  public closeAdd(): any {
    this.table.isEnableAdd = false;
  }

  onRatesSaved(newRate: string, rateType: 'person' | 'class') {
    for (let p of this.coachSalaryCalculators[this.selectedAlias].params) {
      if (p != 'classesRate' && p != 'personsRate') {
        this.params[p] = this.form.get(p).value;
      }
    }
    if (rateType === 'person') {
      this.params['universalRate'] = `0=0/${newRate}`;
    } else {
      this.params['universalRate'] = `${newRate}/0=0`;
    }
    const req: any = {
      coachId: this.table[0],
      coachRegistryId: this.registry.id,
      paymentTypeAlias: this.selectedAlias,
      total: this.calcProgressive(this.params),
      params: JSON.stringify(this.params),
      title: this.form.get('title').value || "Прогрессивная ставка",
    };
    this.saveRates(req);
  }
  private async saveRates(req: any) {
    await this.coachRegistryService.addAccrual(req).then(async (result) => {
      if (result) {
        this.table.isEnableAdd = false;
        this.result.emit(result);
        this.alertsService.alert.next({
          type: 'success',
          message: 'Транзакция сохранена',
          header: 'Успех',
          position: 'top',
          timeout: 2000
        });
      } else {
        console.error(result);
      }
    });
  }
  public async save(): Promise<any> {
    if (this.form.valid) {
      for (let p of this.coachSalaryCalculators[this.selectedAlias].params) {
        if (p != 'classesRate' && p != 'personsRate') {
          this.params[p] = this.form.get(p).value;
        }
      }
      let _total = this.coachSalaryCalculators[this.selectedAlias].func(this.params);
      if (this.selectedAlias == 'subscription') {
        this.params['other'] = isNaN(this.form.get('subscriptions').value) ? 0 : Number.parseFloat(this.form.get('subscriptions').value);
        this.params['subscriptions'] = [];
      }

      const req: any = {
        coachId: this.table[0],
        coachRegistryId: this.registry.id,
        paymentTypeAlias: this.selectedAlias,
        total: _total,
        params: JSON.stringify(this.params),
        title: this.form.get('title').value,
      };

      this.saveRates(req)
    }
  }
  public async openRateConfig(popupType: 'person' | 'class') {
    if (popupType === 'person') {
      this.isOpenPersonRatePopup = true;
    } else {
      this.isOpenClassRatePopup = true;
    }
  }
  public changeAlias(alias) {
    this.aliasParams = []
    this.aliasParams.push({
      name: "title",
      displayName: "Комментарий",
      type: "text",
      formControlName: "title",
      value: ""
    })
    for (let p of this.coachSalaryCalculators[alias].params) {
      this.aliasParams.push({
        name: p || "",
        displayName: this.basicParams[p].paramDisplayName || "",
        type: this.basicParams[p].paramType || "text",
        formControlName: p,
        value: this.params[p]
      })
    }
    this.group = {};
    if (this.aliasParams.length) {
      this.group[this.aliasParams[0].name] = new FormControl(this.aliasParams[0].value.toString().replace('&lt;', '<').replace('&gt;', '>'), Validators.required)
      for (let i = 1; i < this.aliasParams.length; i++) {
        this.group[this.aliasParams[i].name] = new FormControl(this.aliasParams[i].value.toString(), Validators.required)
      }
      this.form = new FormGroup(this.group);
    }
  }

  private calcSalaryClass(params: any): number {
    return params['class'] || 0;
  }

  private calcSalaryPersonInGroup(params: any): number {
    return (params['personInGroupRate'] || 0) * (params['personCount'] || 0);
  }

  private calcSubscriptionPercent(params: any): number {
    return params['subscriptions'] || 0;
  }

  private calcSalary(params: any): number {
    return params['salary'] || 0;
  }

  private calcAdditional(params: any): number {
    return params['other'] || 0;
  }
  private calcProgressive(params: any): number {
    return this.coachesRateCalculate.calcProgressive(params); 
  }
  public getTooltipInfoForClass(key: string): string {
    return this.coachesRateCalculate.tooltipInfo[key]
  }
}
